import React, { useContext } from 'react';
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import { Box, Card, Link, Grid, Divider, Typography } from '@mui/material';
import PrintIcon from '@mui/icons-material/Print';
import { translate } from '@lwtears/lwt-common-frontend/lib/@common/util/i18n-util';
import CurriculumSelector from 'components/common/CurriculumSelector';
import { AssessmentContext } from 'state/providers/AssessmentProvider';
import { useEducatorPacketStore } from 'graph/state/query-hooks/use-get-educator-packets';

const t = (key: string, options?) => translate('ui', key, options);

const useStyles = makeStyles((theme: Theme) => {
  return {
    mainContainer: {
      paddingLeft: theme.spacing(30),
      paddingRight: theme.spacing(30),
      paddingBottom: theme.spacing(10),
    },
    pageHeader: {
      paddingTop: theme.spacing(4),
      paddingBottom: theme.spacing(2),
      '& .MuiGrid-container': {
        alignItems: 'flex-end',
      },
    },
    panel: {
      width: '100%',
      height: '100%',
      border: `1px solid ${(theme.palette as any).grey[600]}`,
      padding: theme.spacing(4),
      '&:hover': {
        transform: 'scale(1.01, 1.01)',
        boxShadow: '0 1px 10px 2px rgb(0 0 0 / 20%)',
      },
    },
    secondaryLink: {
      display: 'flex',
      textDecoration: 'none !important',
      color: theme.palette.black.main + ' !important',
      marginLeft: theme.spacing(4),
      fontFamily: 'HWT Futura',
      paddingTop: theme.spacing(3),
      '&:hover': {
        textDecoration: 'underline !important',
      },
      '& p': {
        paddingLeft: theme.spacing(2),
      },
    },
  };
});

const AdminPackets: React.FC = () => {
  const classes = useStyles();
  const { curriculumId } = useContext(AssessmentContext);
  const [packets] = useEducatorPacketStore(curriculumId);

  return (
    <div className={classes.mainContainer} style={{ flexGrow: 1 }}>
      <Box className={classes.pageHeader}>
        <Grid container item xs={12}>
          <Grid item xs={9}>
            <Typography variant="h1" component="h1" style={{ fontWeight: 'bold' }}>
              {t('adminPackets.title')}
            </Typography>
          </Grid>
          <CurriculumSelector />
        </Grid>
        <Divider />
      </Box>
      {packets?.educatorPackets && !packets.isLoading && (
        <Grid container item xs={12} spacing={2}>
          {packets.educatorPackets.map((pkt, index) => (
            <Grid item xs={4} key={index}>
              <Card className={classes.panel}>
                <Typography variant="h4">{pkt?.title}</Typography>
                <>
                  {pkt?.resources?.map((r) => (
                    <Link
                      underline="always"
                      href={r.url}
                      target="_blank"
                      key={r.id}
                      className={classes.secondaryLink}
                    >
                      <PrintIcon />
                      <Typography variant="body1">{r.title}</Typography>
                    </Link>
                  ))}
                </>
              </Card>
            </Grid>
          ))}
        </Grid>
      )}
    </div>
  );
};

export default AdminPackets;
